import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import CategorySection from "./components/CategorySection";
import FeaturedMovies from "./components/FeaturedMovies";
import HotMovies from "./components/HotMovies";
import NewMovies from "./components/NewMovies";
import FeaturesSection from "./components/FeaturesSection";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as const });
  }, []);

  const handleSearchClick = () => {
    navigate("/category/dongzuo");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <Navbar />
      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[500px] md:h-[650px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20glowing%20screen%2C%20red%20velvet%20seats%2C%20dramatic%20atmospheric%20lighting%2C%20warm%20golden%20accents%2C%20elegant%20and%20immersive%20cinema%20experience%2C%20wide%20shot&width=1600&height=700&seq=hero-cinema-bg&orientation=landscape"
            alt="青柠影院 - 最新电影在线观看"
            title="青柠影院 - 最新电影在线 | 高清电影全集免费看"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>

          {/* Hero Content */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-full max-w-[800px] mx-auto px-4 text-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                最新电影在线<span className="text-primary-400">免费看</span>
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-[600px] mx-auto leading-relaxed">
                海量高清电影全集，热门大片不缓冲。
                <strong className="text-white font-semibold">wifi下流畅观看</strong>，
                电影频道每日更新，追新片快人一步。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <button
                  onClick={handleSearchClick}
                  className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
                >
                  <i className="ri-play-circle-line mr-2"></i>
                  立即观影
                </button>
                <button
                  onClick={() => {
                    navigate("/about");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-semibold rounded-full backdrop-blur-sm border border-white/20 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </button>
              </div>

              {/* Stats */}
              <div className="flex items-center justify-center gap-8 md:gap-12 mt-10">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white">10000+</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">高清片源</div>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white">500万+</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">活跃用户</div>
                </div>
                <div className="w-px h-10 bg-white/20"></div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-white">4K</div>
                  <div className="text-xs md:text-sm text-white/60 mt-1">超清画质</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CategorySection />
        <FeaturedMovies />
        <HotMovies />
        <NewMovies />
        <FeaturesSection />

        {/* CTA Banner */}
        <section className="relative py-16 md:py-20 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20film%20strip%20abstract%20background%2C%20soft%20warm%20golden%20light%2C%20subtle%20movie%20reel%20texture%2C%20elegant%20dark%20background%20with%20gentle%20light%20streaks%2C%20sophisticated%20cinema%20atmosphere&width=1600&height=500&seq=cta-cinema-bg&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          <div className="relative z-10 text-center px-4">
            <h2 className="text-2xl md:text-3xl font-semibold text-white mb-3">
              随时随地，畅享高清观影体验
            </h2>
            <p className="text-white/70 text-sm md:text-base mb-6 max-w-[500px] mx-auto">
              支持手机、平板、电脑多端观看，wifi环境下流畅不缓冲
            </p>
            <button
              onClick={handleSearchClick}
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              开始观看
            </button>
          </div>
        </section>
      </main>
      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "青柠影院",
            url: typeof window !== "undefined" ? window.location.origin : "",
            description:
              "青柠影院提供最新电影在线观看，海量高清电影全集、热门大片免费看。wifi下流畅观看不卡顿，电影频道每日更新。",
            potentialAction: {
              "@type": "SearchAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate:
                  (typeof window !== "undefined" ? window.location.origin : "") +
                  "/category/{search_term_string}",
              },
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "青柠影院",
            url: typeof window !== "undefined" ? window.location.origin : "",
            description:
              "青柠影院 - 最新电影在线观看平台，提供高清电影全集免费看",
            sameAs: ["https://weibo.com", "https://bilibili.com"],
          }),
        }}
      />
    </>
  );
}